<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>部门模块</el-breadcrumb-item>
            <el-breadcrumb-item>部门列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="8">
        <div>
          部门名称：
          <el-input v-model="name"
                    style="width: unset;"
                    placeholder="请输入部门名称"></el-input>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          负责人名称：
          <el-input v-model="contacts"
                    style="width: unset;"
                    placeholder="请输入负责人名称"></el-input>
        </div>
      </el-col>
      <el-col :span="8">
        <el-button type="primary"
                   size="medium"
                   @click="handleCurrentChange(1)">查询</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="add">新增</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData"
              border
              style="width: 95%">
      <el-table-column prop="name"
                       label="部门名称"
                       width="180"></el-table-column>
      <el-table-column prop="deptSize"
                       label="部门人数"
                       width="180"></el-table-column>
      <el-table-column prop="contacts"
                       label="部门负责人"
                       width="180"></el-table-column>
      <el-table-column prop="tel"
                       label="负责人电话"
                       width="120"></el-table-column>
      <el-table-column prop="remark"
                       label="备注"></el-table-column>
      <el-table-column fixed="right"
                       label="操作">
        <template slot-scope="scope">
          <el-button @click="goDetails(scope.row)"
                     type="text"
                     size="small">详情</el-button>
          <el-button @click="del(scope.row)"
                     type="text"
                     size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="grid-content"
                   background
                   @current-change="handleCurrentChange"
                   layout="total, prev, pager, next"
                   :total="totalCount"
                   :page-size="pageSize"
                   :page-count="pageTotal"></el-pagination>
  </div>
</template>
<script>
import { deptSel, deptDel } from "@/api/department";
export default {
  data () {
    return {
      input: "",
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: [],
      dialogFormVisible: false,
      name: '',
      contacts: ''
    };
  },
  mounted () {
    this.getDeptList();
  },
  methods: {
    handleClick (row) {
      console.log(row);
    },
    goDetails (row) {
      this.$router.push({ path: "details", query: row });
    },
    add () {
      this.$router.push({ path: "add" });
    },
    del (row) {
      console.log(row);
      this.$confirm(
        "此操作会删除<" + row.name + ">部门, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          deptDel({ id: row.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.handleCurrentChange(1);
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    handleCurrentChange (e) {
      this.pageNum = e;
      this.getDeptList();
    },
    getDeptList () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        name: this.name,
        contacts: this.contacts,
        states: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      deptSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = [];
          res.gridData.forEach(element => {
            element.deptSize = element.deptSize ? element.deptSize : 0;
            this.tableData.push(element);
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
